import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/500.css";
import "@fontsource/dm-sans/700.css";

import { GatsbyBrowser } from "gatsby";
import React from "react";
import "./src/styles/global.scss";

const CONVERSION_PATH = "/services";

declare global {
  interface Window {
    oaiq: (...args: unknown[]) => void;
  }
}

export const onRouteUpdate: GatsbyBrowser["onRouteUpdate"] = ({ location }) => {
  if (typeof window === "undefined" || !window.oaiq) {
    return;
  }

  const normalizedPath = location.pathname.replace(/\/$/, "") || "/";

  if (normalizedPath === CONVERSION_PATH) {
    window.oaiq("measure", "page_viewed", { type: "contents" });
  }
};
